<template>
  <div>
    <h1 class="headline">Agent Performance</h1>
    <div class="mt-4">
      <date-filter v-model="selectedDate" default-filter="last_7_days"></date-filter>
    </div>
    <DataTable :selected-date="selectedDate" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime'

import DataTable from './DataTable.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'

export default {
  name: 'AgentPerformance',
  components: {
    DataTable,
    DateFilter
  },
  data() {
    return {
      selectedDate: {
        end: dayjs().format(DATETIME.DATE_FORMAT),
        start: dayjs().subtract(7, 'days').format(DATETIME.DATE_FORMAT)
      }
    }
  },
  computed: {
    agentGroupList() {
      return this.$store.state.agentGroups
    },
    agentList() {
      return this.$store.state.agents
    }
  },
  mounted() {
    if (this.agentList.length === 0) {
      this.$store.dispatch('loadAgents')
    }

    if (this.agentGroupList.length === 0) {
      this.$store.dispatch('loadAgentGroups')
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/Performance/index.vue